"use strict";

var DocUtils = require("docxtemplater").DocUtils;
module.exports = DocUtils;


/*****************
 ** WEBPACK FOOTER
 ** ./~/docxtemplater-image-module/js/docUtils.js
 ** module id = 1653
 ** module chunks = 0
 **/